module.exports = __webpack_public_path__ + "img/logo_main_m.fe7b2efc.png";